import React, { Component } from 'react';

var markers = {};

// TODO: Only pass markers as dependency
class Map extends Component {
  render() {
    return (
      <div
        className="App-map"
        ref={mapElement => (this.mapElement = mapElement)}
      />
    );
  }

  componentDidMount() {
    console.log('Component did mount');

    var haarlem = { lat: 52.377408, lng: 4.634038 };
    var map = new this.props.google.maps.Map(this.mapElement, {
      zoom: 14,
      center: haarlem
    });
    // var marker = new this.props.google.maps.Marker({
    //   position: haarlem,
    //   map: map
    // });

    const watchId = this.loadUserLocation(
      this.props.google,
      map,
      this.props.onUserLocationUpdate
    );

    this.setState({
      map: map,
      watchId: watchId
    });
  }

  componentDidUpdate() {
    console.log('Component did update');
    console.log('render: ', this.props.users);

    const ancestorMarkers = Object.assign({}, markers);
    const successorMarkers = {};

    this.props.users.forEach(user => {
      console.log('User: ', user.data());

      if (!user.data().location) {
        return;
      }

      let marker = ancestorMarkers[user.id];

      if (marker) {
          // TODO: Update position
          marker.setPosition({
            lat: user.data().location.latitude,
            lng: user.data().location.longitude
          });
          delete ancestorMarkers[user.id];
      } else {
          marker = new this.props.google.maps.Marker({
          position: {
            lat: user.data().location.latitude,
            lng: user.data().location.longitude
          },
          map: this.state.map
        });
      }

      successorMarkers[user.id] = marker;
    });

    Object.keys(ancestorMarkers).forEach(key => { ancestorMarkers[key].setMap(null); })
    markers = successorMarkers;
  }

  loadUserLocation(google, map, callback) {
    if (!navigator.geolocation) {
      return;
    }

    /* geolocation is available */
    console.log('Geolocation is available');

    return navigator.geolocation.watchPosition(function(position) {
      var pos = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      // var marker = new google.maps.Marker({
      //   position: pos,
      //   map: map,
      //   icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png"
      // });

      // TODO: Set position to state
      map.setCenter(pos);

      callback(pos);
    });
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/Map.js